import { combineReducers } from 'redux';
import projects from './projects';
import { projectsSaga } from './projects';
import { all } from 'redux-saga/effects';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import auth, { authSaga } from './auth';
import contracts, { contractsSaga } from './contracts';
import changeOrders, { changeOrdersSaga } from './change-orders';
import billingPeriod, { billingPeriodsSaga } from './billing-periods';
import partners, { partnersSaga } from './partners';
import bidPackages, { bidPackagesSaga } from './bid-packages';
import bidders, { biddersSaga } from './bidders';
import bidChances, { bidChancesSaga } from './bid-chances';
import vendors, { vendorsSaga } from './vendors';
import expenses, { expensesSaga } from './expenses';
import invoices, { invoicesSaga } from './invoices';
import schedules, { schedulesSaga } from './schedules';
import workRecords, { workRecordsSaga } from './work-records';
import tasks, { tasksSaga } from './tasks';

export const history = createBrowserHistory();
const rootReducer = combineReducers({
  router: connectRouter(history),
  projects,
  auth,
  contracts,
  changeOrders,
  billingPeriod,
  partners,
  bidPackages,
  bidders,
  bidChances,
  vendors,
  expenses,
  invoices,
  schedules,
  workRecords,
  tasks,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;

export function* rootSaga() {
  yield all([
    projectsSaga(),
    authSaga(),
    contractsSaga(),
    changeOrdersSaga(),
    billingPeriodsSaga(),
    partnersSaga(),
    bidPackagesSaga(),
    biddersSaga(),
    bidChancesSaga(),
    vendorsSaga(),
    expensesSaga(),
    invoicesSaga(),
    schedulesSaga(),
    workRecordsSaga(),
    tasksSaga(),
  ]);
}
